import { setDiscoveryRuleDeleteRowData } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';


export type SetDiscoveryRuleDeleteRowProps = ApiMethodBase & {
    type: string;
    row: number;
    id: number;
};

export const setDiscoveryRuleDeleteRow = ({
    type,
    row,
    id,
}: SetDiscoveryRuleDeleteRowProps) => {
    setDiscoveryRuleDeleteRowData(type, row, id);
};
